import {Slot} from '@radix-ui/react-slot'
import type {ButtonHTMLAttributes} from 'react'

import {cn} from '@/lib/utils'

import {buttonVariants, type ButtonVariants} from './variants'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement>, ButtonVariants {
  asChild?: boolean
}

export function Button({className, variant, size, asChild = false, ...props}: ButtonProps) {
  const Component = asChild ? Slot : 'button'
  return <Component data-slot="button" className={cn(buttonVariants({variant, size}), className)} {...props} />
}
